export default __webpack_public_path__ + "static/404-766a90678570b1c6e4d7be01572022b8.svg";